export default __webpack_public_path__ + "static/media/insta18.b423f5b9.webp";